import { Alert, Box, Button, Modal, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useGetBuyFactorDetail } from "../../../hooks/into-warehouse/useGetBuyFactorDetail";
import useBuyFactorStore from "../../../store/into-warehouse/useBuyFactorStore";
import LoadingSpinner from "../../global/loading-spinner";
import BuyFactorDetailItem from "./buy-factor-detail-item";

const useStyles = makeStyles((theme) => ({
  buyFactorDetail: {
    padding: "46px 32px",
    position: "relative",
    [theme.breakpoints.down("360")]: {
      padding: "46px 14px",
    },
    "&:before": {
      position: "absolute",
      content: '""',
      top: 0,
      right: 0,
      width: "100%",
      height: "80%",
      backgroundColor: "#2530B8",
      borderRadius: "0 0 80px 80px",
    },
  },
  buyFactorDetailBox: {
    background: "#fff",
    boxShadow: "0 0 10px rgba(0,0,0,0.05)",
    position: "relative",
    borderRadius: "15px",
    zIndex: "2",
    "&:before": {
      position: "absolute",
      content: '""',
      top: "-8px",
      left: "50%",
      transform: "translate(-50%,0)",
      width: "90%",
      height: "80%",
      backgroundColor: "rgba(255,255,255,0.17)",
      borderRadius: "15px",
      zIndex: "-1",
    },
    "&:after": {
      position: "absolute",
      content: '""',
      top: "-16px",
      left: "50%",
      transform: "translate(-50%,0)",
      width: "80%",
      height: "80%",
      backgroundColor: "rgba(255,255,255,0.17)",
      borderRadius: "15px",
      zIndex: "-1",
    },
  },
  buyFactorDetailHeader: {
    borderBottom: "1px dashed #B9BACC",
    padding: "18px 12px",
    "& span": {
      color: "#ABACBE",
    },
  },
}));

const BuyFactorDetail = () => {
  const classes = useStyles();
  const factorID = useBuyFactorStore((store) => store.factorID);
  const { data, isLoading } = useGetBuyFactorDetail(factorID);
  const factor_info = data?.result?.factor_info;
  const items = data?.result?.items;

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box className={classes.buyFactorDetail}>
          <Box className={classes.buyFactorDetailBox}>
            {data?.data?.status?.code === -1 && (
              <Alert severity="error">{data?.data.msg}</Alert>
            )}
            {!isLoading && (
              <>
                <Box className="page-title" style={{ top: "-88px" }}>
                  {factor_info.provider_name}
                </Box>
                <Box>
                  <Box className={classes.buyFactorDetailHeader}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h3" mb={0.75}>
                        <span>کد فاکتور:</span>
                        <Box display="inline-block" mr={0.75} fontWeight="700">
                          {factor_info.code}
                        </Box>
                      </Typography>
                      <Typography variant="h3" mb={0.75}>
                        <span>تاریخ:</span>
                        <Box display="inline-block" mr={0.75} fontWeight="700">
                          {factor_info.date}
                        </Box>
                      </Typography>
                    </Box>
                    <Typography variant="h3" mb={0.75}>
                      <span>نام:</span>
                      <Box display="inline-block" mr={0.75} fontWeight="700">
                        {factor_info.provider_name}
                      </Box>
                    </Typography>
                    <Typography variant="h3">
                      <span>توضیحات:</span>
                      <Box display="inline-block" mr={0.75} fontWeight="700">
                        {factor_info.description
                          ? factor_info.description
                          : "ندارد"}
                      </Box>
                    </Typography>
                  </Box>
                  <Box className={classes.detailItems}>
                    {items.length === 0 ? (
                      <Alert severity="warning">
                        محصولی در این فاکتور موجود نیست.
                      </Alert>
                    ) : (
                      items.map(({ ...otherProps }, index) => (
                        <BuyFactorDetailItem
                          {...otherProps}
                          key={index}
                          date={factor_info.date}
                        />
                      ))
                    )}
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};
export default BuyFactorDetail;
